import React from 'react';
import { graphql } from 'gatsby';
import { Layout, Seo } from '@layout';
import {
  HeroSection,
  ShopRegistrySection,
  ShopSection,
  RegistryCashFundSection,
  RegistryTopBarSection,
  GuestExperienceSection,
  SupportSection,
  RegistryFaqSection,
  ThankYouNoteSection,
} from '@sections/registry';
import { registryPageData } from '@data-ts/pages/registry';
import { faqQuestionsData } from '@data-ts/components/FaqQuestions';
import { RecommendProducts } from '@sections/shared/GridView';
import { Box } from '@components/Box';
import { Flex } from '@components/Flex';
import { UserContentSection } from '@sections/registry/UserContentSection';
import { TestimonialsCarousel } from '@sections/registry/components/TestimonialsCarousel';
import { testimonialsData } from '@data-ts/components/Testimonials';

const page = 'registry';

interface RegistryBlogs {
  id: string;
  blogs: {
    link: string;
    title: string;
    excerpt: string;
    mediaLink: string;
  }[];
}

interface BlissRegistryData {
  recommendCatalogHomeSections: {
    sections: {
      paginatedCatalogEntities: {
        edges: RecommendProducts;
      };
    }[];
  };
}

interface RegistryPageData {
  bliss: BlissRegistryData;
  featureBlogs: RegistryBlogs;
}

export const query = graphql`
  {
    bliss {
      recommendCatalogHomeSections {
        sections(offset: 1, limit: 1) {
          paginatedCatalogEntities(first: 20) {
            edges {
              node {
                ... on Bliss_ProductCatalogEntityItemGroup {
                  catalogItemGroupData {
                    tileViewItem {
                      id
                      title
                      brand {
                        name
                        publicUrlPath
                      }
                      price {
                        currency {
                          code
                          places
                        }
                        floatingPointDecimalString
                        valueInMinorUnits
                      }
                      publicUrlPath
                      photos {
                        url
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    featureBlogs {
      id
      blogs {
        link
        title
        excerpt
        mediaLink
      }
    }
  }
`;

const Registry = ({ data }: { data: RegistryPageData }) => {
  return (
    <Layout transparentHeaderButtonVariant="primeWeddingWebsites" headerScrollThresholdVh={35} page={page}>
      <Seo
        title={registryPageData.seo.title}
        canonicalURL={'https://withjoy.com/registry/'}
        description={registryPageData.seo.content}
        ogImage={'common/meta_share/registry.jpg'}
      />
      <Box style={{ background: 'linear-gradient(180deg, #FFF 0%, #FFF 84.5%, #F5F5F7 100%)' }}>
        <RegistryTopBarSection />
        <HeroSection />
        <ShopRegistrySection />
      </Box>
      <Flex flexDirection="column" alignItems="center" style={{ backgroundColor: '#F5F5F7' }}>
        <ShopSection products={data.bliss.recommendCatalogHomeSections.sections[0].paginatedCatalogEntities.edges} />
        <RegistryCashFundSection />
        <GuestExperienceSection />
        <ThankYouNoteSection />
        <SupportSection />
        <RegistryFaqSection questionNodes={[...faqQuestionsData.registry, ...faqQuestionsData.general]} />
      </Flex>
      <UserContentSection />
      <TestimonialsCarousel testimonialsData={testimonialsData.registry} />
    </Layout>
  );
};

export default Registry;
